import isNumber from 'lodash/isNumber'

export type OrderJson = {
  id?: number
  customerId: number
  description?: string
  customerOrganizationId?: number
  customerOrganizationName?: string
  idDisplay?: string
  traderId?: number
  traderName?: string
  updatedAt?: string
  isArchived?: boolean
}

export function orderToJson(order: Order): OrderJson {
  return {
    id: order.id,
    customerId: order.customerId,
    description: order.description,
    customerOrganizationId: order.customerOrganizationId,
    customerOrganizationName: order.customerOrganizationName,
    idDisplay: order.idDisplay,
    traderId: order.traderId,
    traderName: order.traderName,
    updatedAt: order.updatedAt,
    isArchived: order.isArchived
  }
}

export class Order {
  static readonly __klearClass = 'Order'

  id?: number
  customerId: number
  description?: string
  customerOrganizationId?: number
  customerOrganizationName?: string
  idDisplay?: string
  traderId?: number
  traderName?: string
  updatedAt?: string
  isArchived?: boolean

  constructor(props: OrderJson) {
    this.id = props.id
    this.customerId = props.customerId
    this.description = props.description
    this.customerOrganizationId = props.customerOrganizationId
    this.customerOrganizationName = props.customerOrganizationName
    this.idDisplay = props.idDisplay
    this.traderId = props.traderId
    this.traderName = props.traderName
    this.updatedAt = props.updatedAt
    this.isArchived = props.isArchived
  }

  get isPersisted(): boolean {
    return isNumber(this.id) && this.id > 0
  }

  toJSON(): OrderJson {
    return orderToJson(this)
  }
}
